<ng-container>

  <div>
    <b>{{ name }}</b>
    <app-info class="formGroupLabel" [wide]="false" [placement]="'left'">
      <div class="tooltipContent">
        <b>Considering</b>
        <ul>
          @for (consider of splitConsidering(); track consider) {
            <div>
              <li>
                {{ consider }}
              </li>
            </div>
          }
        </ul>
      </div>
    </app-info>
  </div>


  <ng-container>
    <div class="row">
      <div class="col-md fieldset">
        <app-visit-exemptions-exemption-common [exemption]="exemption"></app-visit-exemptions-exemption-common>


        <div class="col-md">
          <app-form-group>
            <app-info class="formGroupLabel">
              <label>Vessel type</label>
              <div class="tooltipContent">Name of bunker vessel</div>
            </app-info>
            <app-select [(ngModel)]="exemption.vesselType" (ngModelChange)="resetVesselInfo()" id="vesselType"
                        [options]="vesselTypes"
                        [formatter]="vesselTypesFormatter" required>
            </app-select>
          </app-form-group>
        </div>

        @if (!exemption.vesselType) {
          <div class="col-md">
          </div>
        }

        @if (exemption.vesselType === 'IMO') {
          <div class="col-md">
            <app-form-group label="Vessel name/IMO number">
              <app-search [(ngModel)]="vessel" (ngModelChange)="onVesselChange(vessel)" [searchFunction]="searchVessel"
                          [inputFormatter]="vesselNameFormatter"
                          [minCharacters]="3" dataKey="imoCode" id="vessel">
              </app-search>
            </app-form-group>
            <app-form-group label="First vessel name">
              <input [(ngModel)]="exemption.vesselNameIMO" id="vesselNameIMO" type="text" maxlength="64"
                     class="form-control" readonly>
            </app-form-group>
            <app-form-group label="First vessel IMO">
              <input [(ngModel)]="exemption.vesselIMO" id="vesselIMO" type="text" maxlength="64"
                     class="form-control" readonly>
            </app-form-group>
          </div>
        }

        @if (exemption.vesselType === 'ENI') {
          <div class="col-md">
            <app-form-group label="First vessel name">
              <input [(ngModel)]="exemption.vesselNameENI" id="vesselNameENI" type="text" maxlength="64"
                     class="form-control">
            </app-form-group>
            <app-form-group label="First vessel ENI">
              <input [(ngModel)]="exemption.vesselENI" id="vesselENI" type="text" maxlength="64"
                     class="form-control">
            </app-form-group>
          </div>
        }
      </div>
      <div class="col-md fieldset">

        <div class="col-md">
          <app-form-group label="From">
            <app-date-field [(ngModel)]="exemption.from" id="from" required></app-date-field>
          </app-form-group>
          <app-form-group label="To">
            <app-date-field [(ngModel)]="exemption.to" id="to" required></app-date-field>
          </app-form-group>
        </div>
        <div class="col-md">
        </div>

        <div class="col-md">
          <app-form-group label="Is the location on the bunker map ?">
            <app-yes-no [(ngModel)]="exemption.locationOnBunkerMap" id="locationOnBunkerMap" required></app-yes-no>
          </app-form-group>
        </div>
        <div class="col-md">
        </div>
        <div class="col-md">
          <app-form-group label="Is the terminal qualified as having Bunker Readiness ?">
            <app-yes-no [(ngModel)]="exemption.terminalQualified" id="terminalQualified" required></app-yes-no>
          </app-form-group>
        </div>
        <div class="col-md">
        </div>

        <div class="col-md">
          <app-form-group label="Fuel to be bunkered">
            <app-select [(ngModel)]="exemption.fuelType" (ngModelChange)="resetFuelTypeOther()" id="berthType"
                        [options]="fuelTypes" required>
            </app-select>
          </app-form-group>
        </div>
        <div class="col-md">
          @if (exemption.fuelType === OTHER) {
            <app-form-group label="Other">
              <input [(ngModel)]="exemption.fuelTypeOther" id="fuelTypeOther" type="text" maxlength="256"
                     class="form-control" required>
            </app-form-group>
          }
        </div>
        <div class="col-md">
          <app-form-group>
            <app-info class="formGroupLabel">
              <label>Reason for request for exemption</label>
              <div class="tooltipContent">A minimum of 20 characters is required</div>
            </app-info>
            <textarea [(ngModel)]="exemption.reason" id="reason" type="text" rows="3" minlength="20" maxlength="1024"
                      class="form-control" required></textarea>
          </app-form-group>
        </div>
        <div class="col-md">
          <app-form-group label="Details">
            <textarea [(ngModel)]="exemption.details" id="details" type="text" rows="3" maxlength="256"
                      class="form-control"></textarea>
          </app-form-group>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
